import { Svg, SvgPath, registerSVG } from '../../../src/components/svg';
import type { LogoProps } from '../../types';

export function PlkLogoPrimary(props: LogoProps) {
  return (
    <Svg {...props} viewBox="0 0 151 24">
      <SvgPath
        fillRule="evenodd"
        clipRule="evenodd"
        d="M79.695 0.3172C72.8678 0.3172 68.1411 5.27132 68.1411 12.0964C68.1411 18.9214 72.5931 24 80.418 24C83.9174 24 86.9792 23.1503 89.4337 21.2451L86.6745 16.1944C84.8722 17.4453 82.9326 18.149 80.7163 18.149C77.7704 18.149 76.0325 16.8037 75.3673 14.4672H90.4185C90.5472 13.7892 90.661 12.4697 90.6502 11.2961C90.6095 6.43851 88.0498 0.3172 79.695 0.3172ZM75.3094 9.6826C75.8608 7.4083 77.3069 5.85706 79.7164 5.85706C82.0122 5.85706 83.6728 7.19804 83.8638 9.6826H75.3094Z"
        fill={props.reversed ? '#FFF' : '#FF7D00'}
      />
      <SvgPath
        fillRule="evenodd"
        clipRule="evenodd"
        d="M104.74 1.14755L100.307 10.7018L96.0635 1.14755H88.3931L96.5827 17.471V23.7039H103.944V17.4796L112.559 1.14755H104.74Z"
        fill={props.reversed ? '#FFF' : '#FF7D00'}
      />
      <SvgPath
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.05215 0.0340013C6.4131 -0.0904416 1.91599 0.156299 0 0.297906L0.154481 6.00726L1.98894 5.8914V23.6782H9.06073V19.2347C19.3938 18.7412 21.8097 13.2292 21.8097 9.34147C21.8075 3.82736 17.3126 0.422349 9.05215 0.0340013ZM9.06073 13.6905V5.91929C13.5664 6.1317 14.6499 8.05842 14.6499 9.62898C14.6478 11.8604 13.1523 13.6069 9.06073 13.6905Z"
        fill={props.reversed ? '#FFF' : '#FF7D00'}
      />
      <SvgPath
        fillRule="evenodd"
        clipRule="evenodd"
        d="M121.28 0.3172C114.453 0.3172 109.726 5.27132 109.726 12.0964C109.726 18.9214 114.284 24 121.941 24C125.132 24 127.904 23.3048 130.229 21.7278L127.685 16.4948C126.02 17.5654 124.271 18.1469 122.239 18.1469C119.42 18.1469 117.652 16.8016 116.966 14.4651H132.002C132.13 13.7871 132.248 12.4676 132.238 11.2939C132.193 6.43851 129.635 0.3172 121.28 0.3172ZM116.895 9.6826C117.446 7.4083 118.892 5.85706 121.302 5.85706C123.598 5.85706 125.275 7.22164 125.449 9.6826H116.895Z"
        fill={props.reversed ? '#FFF' : '#FF7D00'}
      />
      <SvgPath
        fillRule="evenodd"
        clipRule="evenodd"
        d="M34.3226 0.458832C27.828 0.458832 22.4254 5.28207 22.4254 12.1221C22.4254 18.9622 27.828 23.7854 34.3226 23.7854C40.8173 23.7854 46.2198 18.9644 46.2198 12.1221C46.2198 5.28207 40.8173 0.458832 34.3226 0.458832ZM34.3763 17.529C31.2201 17.529 29.2205 15.1023 29.2205 12.0792C29.2205 9.05612 31.2223 6.62734 34.3763 6.62734C37.5324 6.62734 39.5321 9.05398 39.5321 12.0792C39.5321 15.1002 37.5324 17.529 34.3763 17.529Z"
        fill={props.reversed ? '#FFF' : '#FF7D00'}
      />
      <SvgPath
        fillRule="evenodd"
        clipRule="evenodd"
        d="M54.9437 0.267868C52.3304 0.145571 47.8762 0.38802 45.9817 0.529627L46.134 6.1832L47.9513 6.06948V23.6803H54.9523V19.2797C65.1845 18.7905 67.5746 13.3344 67.5746 9.48522C67.5725 4.02261 63.1226 0.651925 54.9437 0.267868ZM54.9501 13.7892V6.09308C59.4108 6.30335 60.4835 8.21076 60.4835 9.76629C60.4835 11.9784 59.0031 13.7056 54.9501 13.7892Z"
        fill={props.reversed ? '#FFF' : '#FF7D00'}
      />
      <SvgPath
        fillRule="evenodd"
        clipRule="evenodd"
        d="M144.585 10.2812C143.324 9.77269 141.805 9.21056 140.816 8.75999C139.848 8.32014 139.507 7.88245 139.507 7.21518C139.507 6.3312 140.421 5.84845 141.584 5.84845C143.365 5.84845 144.755 6.6702 146.004 8.00475L149.924 3.92817C148.244 1.66459 145.358 0.237793 141.674 0.237793C136.683 0.237793 132.789 2.64512 132.789 7.39326C132.789 11.1437 134.598 12.946 138.106 14.465C139.101 14.8963 140.434 15.2782 141.431 15.703C142.303 16.0721 142.85 16.4647 142.85 17.1792C142.85 17.8422 142.268 18.3807 140.584 18.3807C139.031 18.3807 136.793 17.7563 135.164 16.6986L132.781 21.5819C135.048 23.2233 137.788 23.897 140.59 23.897C144.942 23.897 149.606 22.0132 149.606 16.9475C149.606 13.1348 147.164 11.3218 144.585 10.2812Z"
        fill={props.reversed ? '#FFF' : '#FF7D00'}
      />
    </Svg>
  );
}

registerSVG('PlkLogoPrimary', PlkLogoPrimary);
